import styled from "@emotion/styled";
import {
  AbsoluteLink,
  H2,
  HeadingGroup,
  List,
  ScreenReaderText,
  Stack,
  Text,
} from "atoms";
import medium_Writing from "assets/images/mediums/medium_Writing.jpg";
import medium_2D3D from "assets/images/mediums/medium_2D3D.jpg";
import medium_Animation from "assets/images/mediums/medium_Animation.jpg";
import medium_Collage from "assets/images/mediums/medium_Collage.jpg";
import medium_Environment from "assets/images/mediums/medium_Environment.jpg";
import medium_Fashion from "assets/images/mediums/medium_Fashion.jpg";
import medium_Film from "assets/images/mediums/medium_Film.jpg";
import medium_Generative from "assets/images/mediums/medium_Generative.jpg";
import medium_Illustration from "assets/images/mediums/medium_Illustration.jpg";
import medium_Music from "assets/images/mediums/medium_Music.jpg";
import medium_Painting from "assets/images/mediums/medium_Painting.jpg";
import medium_Photography from "assets/images/mediums/medium_Photography.jpg";

// NOTE: limit to 12 tags, please!
// [Display label, URLSearchParam string, Source of image]
const artMediums = [
  ["2D", "2D+Artist", medium_2D3D],
  ["Animation", "Animator", medium_Animation],
  ["Collage", "Collage+Artist", medium_Collage],
  ["Environment", "Environment+Artist", medium_Environment],
  ["Fashion", "Fashion+Designer", medium_Fashion],
  ["Film", "Filmmaker", medium_Film],
  ["Generative", "Generative+Artist", medium_Generative],
  ["Illustration", "Illustrator", medium_Illustration],
  ["Music", "Musician", medium_Music],
  ["Painting", "Painter", medium_Painting],
  ["Photography", "Photographer", medium_Photography],
  ["Writing", "Writer", medium_Writing],
] as const;

function MediumTagsBlock() {
  return (
    <Stack as="section" gap="md">
      <HeadingGroup>
        <small>Feeling Adventurous?</small>
        <H2>Explore Mediums</H2>
      </HeadingGroup>

      <div>
        <MediumGrid>
          {artMediums.map(([label, url, src]) => (
            <li key={label}>
              <AbsoluteLink to={`/search?medium=${url}`}>
                <ScreenReaderText>{label}</ScreenReaderText>
              </AbsoluteLink>

              <MediumThumbnail src={src} alt="" />

              <Text
                size="xxs"
                bold
                textAlign="center"
                font="display"
                textTransform="uppercase"
                aria-hidden
              >
                {label}
              </Text>
            </li>
          ))}
        </MediumGrid>
      </div>
    </Stack>
  );
}

const MediumGrid = styled(List)(({ theme }) => ({
  display: "grid",
  gap: theme.spacing.gap,
  lineHeight: 1.4,
  gridTemplateColumns: "repeat(3, 1fr)",
  letterSpacing: theme.spacing.letterSpacing,
  "@media (min-width: 460px)": {
    gridTemplateColumns: "repeat(4, 1fr)",
  },
  [theme.breakpoints.desktop]: {
    gridTemplateColumns: "repeat(6, 1fr)",
  },
  li: {
    position: "relative",
    borderRadius: theme.borderRadius.sm,
  },
  a: {
    textDecoration: "none",
  },
  "a::after": {
    content: "''",
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
  },
}));
MediumGrid.defaultProps = {
  type: "blank",
};

const MediumThumbnail = styled.img({
  aspectRatio: "1",
  overflow: "hidden",
  borderRadius: "inherit",
  display: "block",
  "&+*": {
    padding: ".5rem .25rem",
    margin: 0,
  },
});

export { MediumTagsBlock };
